// extracted by mini-css-extract-plugin
export var backdropBlur = "_lz-0";
export var contentCard = "_lz-5";
export var frame = "_lz-2";
export var image = "_lz-4";
export var imagePane = "_lz-3";
export var modal = "_lz-1";